<template>
  <div :class="['overflow-hidden', 'bg_radial_cb']">
    <Motion
      :initial="{ opacity: 0, scale: 1.2 }"
      :while-in-view="{ opacity: 1, scale: 1 }"
      :transition="{
        type: 'spring',
        stiffness: 20,
        damping: 10,
      }"
      :in-view-options="{
        once: true,
      }"
    >
      <div :class="['page_view', 'lg:pt-30 pt-25 lg:pb-40 pb-40']">
        <CommonBanner
          :title="t('page.index.sectors.fragment.title')"
          :desc="t('page.index.sectors.fragment.desc')"
          class="lg:mb-20 mb-10"
        />
        <!-- 行业卡片组大容器 -->
        <UCarousel
          v-slot="{ item }"
          :items="sectorsItems"
          loop
          :auto-scroll="{ speed: 1, stopOnInteraction: false }"
          drag-free
          dots
          :arrows="!isMdWidth"
          prev-icon="fe:arrow-left"
          next-icon="fe:arrow-right"
          :ui="{
            item: 'basis-auto lg:ps-6 ps-4 cursor-grab active:cursor-grabbing select-none my-1',
            viewport: '',
            prev: [
              'hidden lg:flex',
              'size-12',
              'rounded-full',
              'sm:-inset-s-20',
              'text-xl',
              'bg-default/80 hover:bg-default/95',
            ],
            next: [
              'hidden lg:flex',
              'size-12',
              'rounded-full',
              'sm:-inset-e-20',
              'text-xl',
              'bg-default/80 hover:bg-default/95',
            ],
            dots: 'lg:-mb-8 -mb-6',
          }"
        >
          <!-- 单卡片容器，在此设置统一高度 -->
          <div
            :class="[
              'font-bold text-gray-600 hover:text-primary',
              'lg:h-42 h-36 lg:w-64 w-32',
              'flex flex-col justify-center items-center',
              'backdrop-blur-lg bg-default/80 hover:bg-default',
              'transition-all',
              'rounded-lg',
            ]"
          >
            <UIcon :name="item.icon" class="lg:text-5xl text-4xl lg:mb-3 mb-2" />
            <h3 class="lg:text-xl text-lg w-fit text-center">{{ item?.title }}</h3>
          </div>
        </UCarousel>
      </div>
    </Motion>
  </div>
</template>

<script lang="ts" setup>
  import type { SectorItem } from './type'

  const { t } = useI18n()
  const { isMdWidth } = useClientWidth()

  /** 行业卡片展示内容 */
  const sectorsItems = computed<SectorItem[]>(() => [
    {
      title: t('page.index.sectors.electronics'),
      icon: 'ic:outline-camera-alt',
    },
    {
      title: t('page.index.sectors.technology'),
      icon: 'bx:chip',
    },
    {
      title: t('page.index.sectors.engineering'),
      icon: 'mdi:hammer-wrench',
    },
    {
      title: t('page.index.sectors.cold-chain'),
      icon: 'mdi:snowflake',
    },
    {
      title: t('page.index.sectors.footwearAndApparel'),
      icon: 'icon-park-outline:high-heeled-shoes',
    },
    {
      title: t('page.index.sectors.FMCG'),
      icon: 'streamline:lipstick',
    },
    {
      title: t('page.index.sectors.others'),
      icon: 'ic:baseline-more-horiz',
    },
  ])
</script>
